import * as React from "react";
import {FieldValues, useFormContext, Validate} from "react-hook-form";
import {FloatingLabel, Form} from "react-bootstrap";
import {ValidationMessage} from "./validationMessage";

interface IProps {
    fieldName: string;
    label?: string;
    placeHolder?: string;
    displayName?: string;
    validation: {
        enabled: boolean;
        rules?: Validate<any, FieldValues> | Record<string, Validate<any, FieldValues>> | undefined
    };
    minLength?: number;
    maxLength: number;
    required: boolean;
    defaultValue?: string | number;
    valueAsNumber?: boolean;
    className?: string;
    disabled?: boolean;
    type?: string;
    autoComplete?: string;
    inputMode?: "text" | "search" | "none" | "tel" | "url" | "email" | "numeric" | "decimal";
}

export const TextBox = (props: IProps) => {
    const {register, formState: {errors}} = useFormContext();
    const displayName = props.displayName ?? props.fieldName;

    return (
        <>
            <FloatingLabel controlId={props.fieldName} label={props.label ?? props.placeHolder ?? displayName}>
                <Form.Control
                    {...register(props.fieldName, {
                        required: {
                            value: props.validation.enabled && props.required,
                            message: `${displayName} is required.`
                        },
                        minLength: {
                            value: props.minLength ?? 0,
                            message: `${displayName} has a minimum length of ${props.minLength} characters.`
                        },
                        maxLength: {
                            value: props.maxLength,
                            message: `${displayName} has a maximum length of ${props.maxLength} characters.`
                        },
                        valueAsNumber: props.valueAsNumber ?? false,
                        validate: props.validation.enabled ? {
                            ...props.validation.rules
                        } : {}
                    })}
                    defaultValue={props.defaultValue}
                    aria-invalid={errors[props.fieldName] ? "true" : "false"}
                    className={`${props.className ? `${props.className} ` : ''}${errors[props.fieldName] ? ' form-error-border' : ''}`}
                    type={props.type ?? "text"}
                    placeholder={props.placeHolder ?? displayName}
                    disabled={(props.disabled ?? false)}
                    autoComplete={props.autoComplete ?? "on"}
                    inputMode={props.inputMode}
                />
            </FloatingLabel>
            <ValidationMessage fieldName={props.fieldName}/>
        </>
    );
};
